import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { ImageItem23 } from '#client/components/Grid';

export default function IllustrationImage() {
  return (
    <ImageItem23>
      <SharedAsset
        alt=""
        src="/s2/vector/pbf-banking.svg"
      />
    </ImageItem23>
  );
}
